// src/services/authService.js

import axiosInstance from '../axiosInstance';

// Authenticate user and get token
export const login = async (credentials) => {
  try {
    const response = await axiosInstance.post('/auth/login', credentials);
    return response.data;
  } catch (error) {
    console.error('Login error:', error.response?.data?.message || error.message);
    throw error;
  }
};

// Register a new user
export const register = async (userInfo) => {
  try {
    const response = await axiosInstance.post('/auth/register', userInfo);
    return response.data;
  } catch (error) {
    console.error('Registration error:', error.response?.data?.message || error.message);
    throw error;
  }
};

// Logout user
export const logoutUser = async () => {
  try {
    const response = await axiosInstance.post('/auth/logout');
    return response.data;
  } catch (error) {
    console.error('Logout error:', error.response?.data?.message || error.message);
    throw error;
  }
};

// Get current user
export const getCurrentUser = async () => {
  try {
    const response = await axiosInstance.get('/auth/me');
    return response.data;
  } catch (error) {
    console.error('Error fetching current user:', error.response?.data?.message || error.message);
    throw error;
  }
};
